/* The two READ affordances in a task's foot — the way into the full session (`SessionLink`) and
 * into the whole survey (`SurveyLink`). Buttons drawn as text: no fill, no border.
 *
 * TEXT, not a fourth button. The row's primary is the one real action on it and keeps the only
 * filled treatment; a ghost or an ink pill here would read as a second control of equal standing,
 * which is exactly what this must not be. It takes `--fs-micro` in `--text-2` — the meta line's own
 * voice, which is the register of everything on these rows that states rather than asks.
 *
 * It costs either row no height: it stands beside a control cluster that is 28px tall, so it sits
 * in space the row already reserved. That is why it is here rather than under a feedback card's
 * chips, where it would have grown every session row past the reserve `FeedbackCard` draws for it
 * and moved the card as the queue landed.
 *
 * The underline appears on hover and on focus rather than at rest: at rest the row is a reading
 * surface and a permanent rule under two words competes with the ring beside it; `base.css` already
 * strips the default. */
.link {
  display: inline-flex;
  padding: var(--space-0);
  background: none;
  border: none;
  flex: none;
  gap: var(--space-6px);
  align-self: center;
  align-items: center;
  font-size: var(--fs-micro);
  font-weight: var(--fw-bold);
  line-height: var(--lh-normal);
  color: var(--text-2);
  cursor: pointer;
  transition-duration: var(--dur-fast);
  transition-property: color;
  transition-timing-function: var(--ease);
}

.link:hover {
  color: var(--text);
  text-decoration: underline;
}

/* `--accent` on a neutral, unfilled control: a neutral ring on a neutral edge is the one
 * combination that disappears — the same rule the two icon buttons beside it follow. */
.link:focus-visible {
  color: var(--text);
  text-decoration: underline;
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}
